"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var array_1 = require("./array");

var string_1 = require("./string");

exports.retrieveErrors = function (responseData, defaultError) {
  var messageErrors = '';
  if (!responseData) return defaultError;

  if (responseData.errors) {
    var errorMessageForConcat = [];
    responseData.errors.map(function (item) {
      return item.message && errorMessageForConcat.push(item.message);
    });
    messageErrors = string_1.concatMessages(errorMessageForConcat);
  }

  return messageErrors && !array_1.isEmpty(messageErrors) ? messageErrors : defaultError;
};

exports.retrieveSuccessMessage = function (responseData, defaultError) {
  return responseData && responseData.message ? responseData.message : defaultError;
};

var MESSAGE_UTILS = {
  retrieveErrors: exports.retrieveErrors,
  retrieveSuccessMessage: exports.retrieveSuccessMessage
};
exports.default = MESSAGE_UTILS;